import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { symbolSearchConstants, queryParamConstants, headerConstants } from '../../constants';
import { ISearchResponse } from '../account-search/account-search.model';
import { ISymbolSearchCriteria, IMdsSymbolSearchResponse } from './symbol-search.model';
import { AppSettingsService } from '@charlesschwab/as-ui-core';

@Injectable({
  providedIn: 'root'
})
export class SymbolSearchService {
  constructor(
    private http: HttpClient,
    private settingsService: AppSettingsService
  ) {}

  getAvailableFundsForAccount(criteria: ISymbolSearchCriteria): Observable<any> {
    let url =
      `${this.settingsService.settings.bffGatewayUrl}/api/ria.SacAipExperience/v1/EligibleFunds` +
      '?' +
      symbolSearchConstants.accountIdQueryKey +
      '=' +
      queryParamConstants.secureClientIdKeyOne;

    if (criteria.itemIssueId != null && criteria.itemIssueId != undefined) {
      url = url + '&' + symbolSearchConstants.itemIssueIdQueryKey + '=' + criteria.itemIssueId;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        [headerConstants.schwabClientIdsKey]: [queryParamConstants.secureClientIdKeyOne] + '=' + criteria.accountId
      })
    };

    return this.http
      .get<ISearchResponse>(url, httpOptions)
      .pipe(map((response: ISearchResponse) => response))
      .pipe(
        catchError((error) => {
          console.log('Error retrieving search data ', error);
          return new Observable((s) => s.error('Data is not available at this time.'));
        })
      );
  }

  getMdsSymbolSearchResults(criteria: ISymbolSearchCriteria): Observable<any> {
    const url =
      `${this.settingsService.settings.symbolSearchUrl}` +
      '?' +
      symbolSearchConstants.mdsSymbolSearchQueryKey +
      '=' +
      criteria.searchTerm +
      '&limit=25&type=MF';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json'
      })
    };

    return this.http
      .get<IMdsSymbolSearchResponse>(url, httpOptions)
      .pipe(map((response: IMdsSymbolSearchResponse) => response))
      .pipe(
        catchError((error) => {
          console.log('Error retrieving MDS symbol search data ', error);
          return new Observable((s) => s.error('Data is not available at this time.'));
        })
      );
  }
}
